<div class="modal-body">
  <div class="d-flex selected-reminder">
    <div class="pr-2"><i class="fa-regular fa-calendar fa-gray fa-normal"></i></div>
    <div class="d-flex flex-column">
      <app-skeleton-loader [containerClasses]="" [styles]="{ height: '20px', width: '100px' }"> </app-skeleton-loader>
      <app-skeleton-loader [containerClasses]="" [styles]="{ height: '18px', width: '200px' }"> </app-skeleton-loader>
    </div>
  </div>
  <div class="mt-3">
    <div class="form-group b-all remindersList">
      @for (i of loopArray; track i) {
        <div class="d-flex px-3 py-2 input-show">
          <div>
            <app-skeleton-loader [containerClasses]="'mr-2'" [styles]="{ height: '20px', width: '20px' }"> </app-skeleton-loader>
            <app-skeleton-loader [containerClasses]="" [styles]="{ height: '20px', width: '100px' }"> </app-skeleton-loader>
          </div>
          <div class="ml-auto">
            <app-skeleton-loader [containerClasses]="''" [styles]="{ height: '20px', width: '100px' }"> </app-skeleton-loader>
          </div>
        </div>
      }
    </div>
  </div>
</div>
